import { BaseModel } from './base';

// Enums

export enum UpdateType {
  news = 0,
  appUpdate = 1,
  newFeature = 2,
  newIntegration = 3,
  article = 4,
  releaseNotes = 5,
}

export const UpdateTypeLabels: Record<UpdateType, string> = {
  [UpdateType.news]: 'api.models.update.news',
  [UpdateType.appUpdate]: 'general.update',
  [UpdateType.newFeature]: 'review.feature',
  [UpdateType.newIntegration]: 'integration.label',
  [UpdateType.article]: 'api.models.update.article',
  [UpdateType.releaseNotes]: 'general.updates',
};

export enum UpdateStatus {
  draft = 0,
  published = 1,
}

export const UpdateStatusLabels: Record<UpdateStatus, string> = {
  [UpdateStatus.draft]: 'general.draft',
  [UpdateStatus.published]: 'customPage.published',
};

// Helper Classes

export class UpdateNewsCount extends BaseModel {}

// Main Model

export class Update extends BaseModel {
  type!: UpdateType;
  status!: UpdateStatus;

  get isUpdateTypeNews(): boolean {
    return this.type === UpdateType.news;
  }

  get isUpdateTypeAppUpdate(): boolean {
    return this.type === UpdateType.appUpdate;
  }

  get isUpdateTypeNewFeature(): boolean {
    return this.type === UpdateType.newFeature;
  }

  get isUpdateTypeNewIntegration(): boolean {
    return this.type === UpdateType.newIntegration;
  }

  get isUpdateTypeArticle(): boolean {
    return this.type === UpdateType.article;
  }

  get isUpdateTypeReleaseNotes(): boolean {
    return this.type === UpdateType.releaseNotes;
  }

  get isUpdateStatusDraft(): boolean {
    return this.status === UpdateStatus.draft;
  }

  get isUpdateStatusPublished(): boolean {
    return this.status === UpdateStatus.published;
  }
}
